import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid auto-rows-fr grid-cols-2 gap-4" }
const _hoisted_2 = { class: "h-full" }
const _hoisted_3 = { class: "mt-4 gap-4 text-sm" }
const _hoisted_4 = ["href"]

import { HelpCircleIcon } from '@klausapp/ui-kit/icons'
import ButtonCard from '@/modules/workspace/components/ButtonCard.vue'
import { session } from '@/composables/useSession'
import QModal from '@/components/QModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AssignmentTypeModal',
  props: {
    id: {},
    showModal: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

const close = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(QModal, {
    show: _ctx.showModal,
    title: _ctx.$t('settings.workspaces.assignments_v_2.create'),
    subtitle: _ctx.$t('settings.workspaces.assignments.select_type'),
    "close-button": "",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, {
            to: { name: 'workspace.assignments.agent-qa.new', params: { id: _ctx.id } }
          }, {
            default: _withCtx(() => [
              _createVNode(ButtonCard, {
                "data-testid": "agent-qa-btn",
                tag: "button",
                title: _ctx.$t('settings.workspaces.assignments.agent_qa.title'),
                description: _ctx.$t('settings.workspaces.assignments.conversation_qa.description')
              }, null, 8 /* PROPS */, ["title", "description"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["to"])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: { name: 'workspace.assignments.reviewer-qa.new', params: { id: _ctx.id } }
            }, {
              default: _withCtx(() => [
                _createVNode(ButtonCard, {
                  "data-testid": "reviewer-qa-btn",
                  tag: "button",
                  class: "h-full",
                  title: _ctx.$t('settings.workspaces.assignments.reviewer_qa.title'),
                  description: _ctx.$t('settings.workspaces.assignments.reviewer_qa.description')
                }, null, 8 /* PROPS */, ["title", "description"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(session).features.gradeTheReviewerDev)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "content-link !flex items-center",
              target: "_blank",
              rel: "noopener noreferral",
              href: _ctx.$t('support_links.zendesk_help')
            }, [
              _createVNode(_unref(HelpCircleIcon), { class: "icon-m mr-2" }),
              _createTextVNode(_toDisplayString(_ctx.$t('settings.workspaces.assignments.select_type_help_text')), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_4))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show", "title", "subtitle"]))
}
}

})